import { query_autoValutazione_byTenant_latest } from "../../businessLogic/query/autovalutazioneQueries";
import { query_autoValutazioneAvvocato_byTenant_latest } from "../../businessLogic/query/autovalutazioneAvvocatoQueries";
import { useQuery } from "@1f/react-sdk";
import { query_autoValutazione_byExpireDate } from "../../businessLogic/query/autovalutazioneQueries";
import { query_autoValutazioneAvv_byExpireDate } from "../../businessLogic/query/autovalutazioneAvvocatoQueries";

export const AutovalutazioneApi = () => {
    const apiAutovalByTenantLatest = useQuery(
        query_autoValutazione_byTenant_latest,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAutovalAvvByTenantLatest = useQuery(
        query_autoValutazioneAvvocato_byTenant_latest,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAutovalutazioneByExpire = useQuery(
        query_autoValutazione_byExpireDate,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiAutovalutazioneAvvByExpire = useQuery(
        query_autoValutazioneAvv_byExpireDate,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );  

    const GetLastAutovalutazione = async (tenantId,aziendaId) => {
        try {
            let autovalutazioneResponse = await apiAutovalByTenantLatest.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId
            })
            if(autovalutazioneResponse?.data?.errors){
                throw new Error(autovalutazioneResponse.data.errors[0]?.message || "GraphQL error");
            }
            return autovalutazioneResponse?.data?.data?.autovalutazione?.[0]
        } catch (error) {
            throw new Error("Error fetching last autovalutazione: " + error.message);
        }
    }
    const GetLastAutovalutazioneAvvocati = async (tenantId,aziendaId) => {
        try {
            let autovalutazioneAvvResponse = await apiAutovalAvvByTenantLatest.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId
            })
            if(autovalutazioneAvvResponse?.data?.errors){
                throw new Error(autovalutazioneAvvResponse.data.errors[0]?.message || "GraphQL error");
            }
            return autovalutazioneAvvResponse?.data?.data?.autovalutazione_avvocati?.[0]
        } catch (error) {
            throw new Error("Error fetching last autovalutazione avvocati: " + error.message);
        }
    }
    const GetAutovlautazioniByExpire = async (tenantId,aziendaId) => {
        try {
            let autovalutazioneResponse = await apiAutovalutazioneByExpire.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                dtFrom: new Date(),
                dtTo: new Date(new Date().setMonth(new Date().getMonth() + 6)),
            });
            if(autovalutazioneResponse && autovalutazioneResponse.data){
                return autovalutazioneResponse.data.data.autovalutazione
            }
        } catch (error) {
            throw new Error("Error fetching autovalutazione by expire date");
        }
    }
    const GetAutovlautazioniAvvocatiByExpire = async (tenantId,aziendaId) => {
        try {
            let autovalutazioneAvvResponse = await apiAutovalutazioneAvvByExpire.fetch({
                tenantId: tenantId,
                aziendaId: aziendaId,
                dtFrom: new Date(),
                dtTo: new Date(new Date().setMonth(new Date().getMonth() + 6)),
            });
            if(autovalutazioneAvvResponse && autovalutazioneAvvResponse.data){
                return autovalutazioneAvvResponse.data.data.autovalutazione_avvocati
            }
        } catch (error) {
            throw new Error("Error fetching autovalutazione avvocati by expire date");
        }
    }

    return {
        GetLastAutovalutazione,
        GetLastAutovalutazioneAvvocati,
        GetAutovlautazioniByExpire,
        GetAutovlautazioniAvvocatiByExpire
    }
}